import { Noun } from '../../types'

const пизда: Noun = {
  type: 'noun',
  nominativeSingular: 'пизда',
  genitiveSingular: 'пизды',
  dativeSingular: 'пизде',
  accusativeSingular: 'пизду',
  instrumentalSingular: 'пиздой',
  prepositionalSingular: 'пизде',
  nominativePlural: 'пизды',
  genitivePlural: 'пизд',
  dativePlural: 'пиздам',
  accusativePlural: 'пизды',
  instrumentalPlural: 'пиздами',
  prepositionalPlural: 'пиздах',
}

export default пизда
